import { render } from "./NotificationsListItem.vue?vue&type=template&id=5ce5d8e6&scoped=true"
import script from "./NotificationsListItem.vue?vue&type=script&lang=ts"
export * from "./NotificationsListItem.vue?vue&type=script&lang=ts"

import "./NotificationsListItem.vue?vue&type=style&index=0&id=5ce5d8e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5ce5d8e6"

export default script